import { MigrateFunctionBuilder } from '@salsita-ai/platform-project-sdk/domain';
import { modelVersion, modelVersions } from '../../__generated/admin-model/index.js';
import { migrateToV2 } from './v2.js';
import { migrateToV3 } from './v3.js';
import { migrateToV4 } from './v4.js';
export const migrations = {
    2: migrateToV2,
    3: migrateToV3,
    4: migrateToV4
};
export const migrateAdmin = MigrateFunctionBuilder.fromVersions(modelVersions).to(modelVersion).using(migrations).build();

//# sourceMappingURL=index.js.map